import React, { PropsWithChildren } from 'react';
import { i18n_next } from '@yi/i18n/phrases/i18n_next';
import { i18n_previous } from '@yi/i18n/phrases/i18n_previous';

import { Link } from 'gatsby';
import { IconChevronLeft, IconChevronRight, PrintHidden, useLocale } from '~/components';

interface Props {
  nextPath: string | null;
  prevPath: string | null;
}

const linkStyle: React.CSSProperties = {
  textTransform: 'uppercase',
  fontSize: '12px',
};

export const PrevNextContent: React.FC<PropsWithChildren<Props>> = ({ nextPath, prevPath }) => {
  const { locale } = useLocale();
  return (
    <PrintHidden>
      <section style={{ marginTop: '5vh' }}>
        {prevPath && (
          <Link to={prevPath} style={{ ...linkStyle, float: 'left', marginTop: '5px' }}>
            <IconChevronLeft style={{ marginLeft: '2px', marginBottom: '2px' }} />
            {i18n_previous(locale)}
          </Link>
        )}
        {nextPath && (
          <Link to={nextPath} style={{ ...linkStyle, float: 'right', marginTop: '5px' }}>
            {i18n_next(locale)}
            <IconChevronRight style={{ marginLeft: '2px', marginBottom: '2px' }} />
          </Link>
        )}
      </section>
    </PrintHidden>
  );
};
